"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldEditorHeight = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var mobx_1 = require("mobx");
var icon_1 = require("../../../components/icon");
var icons_1 = require("../../../components/icon/icons");
var menu_1 = require("../../../components/menu/menu");
var menu_item_1 = require("../../../components/menu/menu.item");
var menu_item_style_1 = require("../../../components/menu/menu.item.style");
var theme_1 = require("../../../components/theme");
var i18n_1 = require("../../../i18n");
var mithril_1 = require("../../../mithril");
var services_1 = require("../../../services");
var form_palette_1 = require("../form.palette");
var form_field_editor_1 = require("./form.field.editor");
var CSS = {
    container: 'c-FdcHeight',
    title: 'c-FdcHeight__title',
    list: 'c-FdcHeight__list',
    menu: 'c-FdcHeight__menu',
    menuContainer: 'c-FdcHeight__menuContainer',
    option: 'c-FdcHeight__option',
    value: 'c-FdcHeight__value',
    ghost: 'c-FdcHeight__ghost',
    icon: {
        icon: 'c-FdcHeight__icon',
        label: 'c-FdcHeight__icon-label'
    },
    selected: 'c-FdcHeight__selected'
};
(0, theme_1.addStyles)((_a = {},
    _a[CSS.container] = {
        width: '100%',
        display: 'flex',
        'flex-direction': 'column',
        '& .mdl-button': {
            height: 'fit-content',
            width: 'fit-content'
        }
    },
    _a[CSS.list] = {
        display: 'flex',
        width: '100%',
        'align-items': 'center'
    },
    _a[CSS.title] = {
        'font-weight': 'bold',
        'margin-bottom': theme_1.DefaultTheme.space(1),
        color: theme_1.DefaultTheme.font.color.supporting
    },
    _a[CSS.option] = {
        width: '320px',
        'text-align': 'left',
        display: 'flex',
        'align-items': 'center'
    },
    _a[CSS.selected] = {
        width: '320px',
        'text-align': 'left',
        display: 'flex',
        'align-items': 'center'
    },
    _a[CSS.ghost] = {
        color: theme_1.DefaultTheme.font.color.supporting
    },
    _a[CSS.value] = {
        width: '520px', // TODO this is from the input width
        'text-align': 'left'
    },
    _a[CSS.icon.icon] = {
        margin: '0 4px',
        'font-style': 'normal'
    },
    _a[CSS.icon.label] = {
        'border-radius': '50%',
        border: '1px solid ' + theme_1.DefaultTheme.background.grey,
        'background-color': theme_1.DefaultTheme.background.lightGrey,
        'font-weight': 'bold',
        'font-size': '12px',
        height: '16px',
        width: '16px',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        margin: '0 8px'
    },
    _a[CSS.menu] = (_b = {},
        _b["& .".concat(menu_item_style_1.CSS.item)] = {
            'padding-top': theme_1.DefaultTheme.space(1),
            'padding-bottom': theme_1.DefaultTheme.space(1),
            'line-height': theme_1.DefaultTheme.space(6)
        },
        _b),
    _a[CSS.menuContainer] = {
        display: 'flex',
        'flex-direction': 'column',
        position: 'relative'
    },
    _a));
var FormFieldEditorHeight = /** @class */ (function (_super) {
    tslib_1.__extends(FormFieldEditorHeight, _super);
    function FormFieldEditorHeight(designer, field) {
        var _this = _super.call(this, designer, field) || this;
        _this.list = _this.getListOfTitleFields(_this.field.parent);
        _this.list.unshift({ displayName: 'Default', fieldId: null, fieldType: null });
        _this.annotationMenu = new menu_1.MenuComponent({
            items: function () { return _this.viewListItems(); },
            className: CSS.container
        });
        _this.annotationLabel = _this.list.find(function (l) { return l.fieldId === _this.field.annotationLabelFieldId; }) || _this.list[0];
        return _this;
    }
    FormFieldEditorHeight.prototype.getListOfTitleFields = function (subform) {
        var _this = this;
        var list = [];
        if (subform.parent != null) {
            list.push.apply(list, this.getListOfTitleFields(subform.parent));
        }
        list.push.apply(list, subform.fields.map(function (x) {
            var item = {
                displayName: x.displayName,
                fieldId: x.fieldId.split(':').pop(),
                fieldType: x.type,
                parentDisplayName: x.parent.parent ? x.parent.displayName : undefined
            };
            if (x.fieldId === _this.field.fieldId) {
                item.displayName = 'Self-Title (' + x.displayName + ')';
            }
            return item;
        }));
        return list;
    };
    FormFieldEditorHeight.prototype.getIcon = function (icon) {
        return icon ? icon_1.Icon.view(form_palette_1.FIELD_TYPE_DISPLAY[icon].icon, { className: CSS.icon.icon }) : (0, mithril_1.m)('i', {
            className: CSS.icon.label + ' ' + CSS.icon.icon,
            title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_LABEL)
        }, 'L');
    };
    FormFieldEditorHeight.prototype.getLabelWithNode = function () {
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_MARKER_LABEL)) {
            return (0, mithril_1.m)('div', { className: CSS.container }, [
                (0, mithril_1.m)('div', { className: "".concat(CSS.option, " ").concat(CSS.title) }, 'Label With'),
                (0, mithril_1.m)('div', { className: CSS.menuContainer }, [
                    (0, mithril_1.m)('button', { className: "mdl-button ".concat(CSS.selected), title: 'LABEL WITH', onclick: this.annotationMenu.show }, [
                        this.getIcon(this.annotationLabel.fieldType),
                        this.annotationLabel.parentDisplayName ? "".concat(this.annotationLabel.parentDisplayName, " > ").concat(this.annotationLabel.displayName) : this.annotationLabel.displayName,
                        icon_1.Icon.view(icons_1.MaterialIcon.KEY_DOWN)
                    ]),
                    this.annotationMenu.view()
                ])
            ]);
        }
        return null;
    };
    //default view
    FormFieldEditorHeight.prototype.viewInfoRW = function () {
        var node = (0, mithril_1.m)('div', { className: CSS.list }, [
            this.getLabelWithNode()
        ]);
        return node;
    };
    FormFieldEditorHeight.prototype.viewListItems = function () {
        var _this = this;
        var items = [];
        var _loop_1 = function (i) {
            var option = this_1.list[i];
            items.push({
                view: menu_item_1.MenuItemComponent.view([this_1.getIcon(option.fieldType), option.parentDisplayName ? "".concat(option.parentDisplayName, " > ").concat(option.displayName) : option.displayName]),
                action: function () { return _this.changeAnnotationField(option); }
            });
        };
        var this_1 = this;
        for (var i = 0; i < this.list.length; i++) {
            _loop_1(i);
        }
        return items;
    };
    FormFieldEditorHeight.prototype.changeAnnotationField = function (key) {
        this.setAnnotationLabelFieldId(key.fieldId);
        this.annotationLabel = key;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], FormFieldEditorHeight.prototype, "annotationLabel", void 0);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], FormFieldEditorHeight.prototype, "changeAnnotationField", null);
    return FormFieldEditorHeight;
}(form_field_editor_1.FormFieldEditor));
exports.FormFieldEditorHeight = FormFieldEditorHeight;
//# sourceMappingURL=form.field.editor.height.js.map